<!--<app-toolchain-instance-table [toolchainInstances]="toolchainInstances"></app-toolchain-instance-table>-->
<div class="newTemplate" (click)="addNewTemplate()">
    <div class="templateButton">
        <hexagon
            [icon]="'plus'"
            [hover]="true"
            [outerColor]="'darkgreen'"
            (click)="addEntryToSelected()"
        ></hexagon>
    </div>
    <div class="label"><h3>Neues Template</h3></div>
</div>
<br />
<app-toolchain-template-table
    [toolchainTemplates]="toolchainTemplates"
    [toolchainInstances]="toolchainInstances"
    (deleteTemplateEvent)="deleteToolchainTemplate($event)"
    (deleteToolchainEvent)="deleteToolchain($event)"
    (reloadToolchainsAndTemplatesEvent)="loadToolchainTemplatesAndInstances()"
></app-toolchain-template-table>
